import {ChangeDetectionStrategy, Component, Input, OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {randomUUIDGenerator} from 'app/core/helpers/uuid';
import {Subject} from 'rxjs';

@Component({
    selector: 'inline-selector-item',
    template: '<ng-template #ref><ng-content></ng-content></ng-template>',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InlineSelectorItemComponent implements OnChanges {
    @Input() value: any;
    @Input() label: string;
    @Input() image: TemplateRef<any>;
    @Input() title: string;
    @Input() disabled: boolean = false;
    changed$ = new Subject();
    id = randomUUIDGenerator();
    @ViewChild(TemplateRef, {static: true}) ref;

    ngOnChanges() {
        this.changed$.next();
    }
}
